import { hot } from "react-hot-loader/root";
import React from "react";
import { i18n } from "../utils/utils";
import { Columns, Column } from "@sparkpost/matchbox";
import {
  DoNotTouch,
  Feedback,
  MarkEmailRead,
  Telegram,
} from "@sparkpost/matchbox-icons";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import Section from "./Section";

const COLORS = ["#1273e6", "#CACACA"];

const getPercentage = (number, total) => {
  if (number == 0) {
    return 0;
  }

  return parseFloat((number * 100) / total).toFixed(2);
};

const getPieChartData = (number, total) => {
  return [
    { value: parseInt(number) },
    { value: parseInt(total) - parseInt(number) },
  ];
};

const StatPie = ({ number, total, title }) => {
  const pieChartData = getPieChartData(number, total);

  return (
    <div className="pie-and-title">
      <ResponsiveContainer width="99%" height={200}>
        <PieChart>
          <Pie
            data={pieChartData}
            // cx={100}
            // cy={100}
            innerRadius={70}
            outerRadius={90}
            startAngle={90}
            endAngle={450}
            paddingAngle={0}
            dataKey="value"
          >
            {pieChartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <header className="title">
        <h6>
          {title} <strong>{`${getPercentage(number, total)}%`}</strong>
        </h6>
      </header>
    </div>
  );
};

const MetricsCharts = ({ data }) => {
  if (!data) {
    return null;
  }

  const total = data.targeted;
  const iconSize = 36;

  return (
    <div className="metrics-charts-container">
      <Columns>
        <Column className="first-col">
          <Section>
            <div className="metrics-box summary targeted">
              <Columns>
                <Column className="icon-col" width="40">
                  <Telegram size={iconSize} className="icon" />
                </Column>
                <Column className="content-col">
                  <h3>{i18n("Metrics.Targeted")}</h3>
                  <p className="stat">{data.targeted}</p>
                </Column>
              </Columns>
            </div>
          </Section>
          <Section className="engagement-box-container">
            <h2>{i18n("Metrics.EngagementRates")}</h2>
            <div className="engagement-box">
              <p className="stat">{`${getPercentage(
                data.opened,
                data.accepted
              )}%`}</p>
              <p className="caption">
                {i18n("Metrics.OpenRate")} <small>({data.opened})</small>
              </p>
            </div>
            <hr />
            <div className="engagement-box">
              <p className="stat">{`${getPercentage(
                data.clicked,
                data.accepted
              )}%`}</p>
              <p className="caption">
                {i18n("Metrics.ClickRate")} <small>({data.clicked})</small>
              </p>
            </div>
          </Section>
        </Column>
        <Column>
          <Section>
            <div className="metrics-box summary accepted">
              <Columns>
                <Column className="icon-col" width="40">
                  <MarkEmailRead size={iconSize} className="icon" />
                </Column>
                <Column className="content-col">
                  <h3>{i18n("Metrics.Delivered")}</h3>
                  <p className="stat">{data.accepted}</p>
                </Column>
              </Columns>
            </div>

            <hr />

            <StatPie
              number={data.accepted}
              total={total}
              title={i18n("Metrics.DeliveredRate")}
            />
          </Section>
        </Column>
        <Column>
          <Section>
            <div className="metrics-box summary bounced">
              <Columns>
                <Column className="icon-col" width="40">
                  <Feedback size={iconSize} className="icon" />
                </Column>
                <Column className="content-col">
                  <h3>{i18n("Metrics.Bounced")}</h3>
                  <p className="stat">{data.bounce}</p>
                </Column>
              </Columns>
            </div>

            <hr />

            <StatPie
              number={data.bounce}
              total={total}
              title={i18n("Metrics.BounceRate")}
            />
          </Section>
        </Column>
        <Column>
          <Section>
            <div className="metrics-box summary rejected">
              <Columns>
                <Column className="icon-col" width="40">
                  <DoNotTouch size={iconSize} className="icon" />
                </Column>
                <Column className="content-col">
                  <h3>{i18n("Metrics.Rejected")}</h3>
                  <p className="stat">{data.rejected + data.admin_bounce}</p>
                </Column>
              </Columns>
            </div>

            <hr />

            <StatPie
              number={data.rejected + data.admin_bounce}
              total={total}
              title={i18n("Metrics.RejectedRate")}
            />
          </Section>
        </Column>
      </Columns>
    </div>
  );
};

export default hot(MetricsCharts);
